/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CompanyForDisplay
 */
export interface CompanyForDisplay {
  /**
   *
   * @type {string}
   * @memberof CompanyForDisplay
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof CompanyForDisplay
   */
  displayName?: string
}

export function CompanyForDisplayFromJSON(json: any): CompanyForDisplay {
  return CompanyForDisplayFromJSONTyped(json, false)
}

export function CompanyForDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyForDisplay {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    displayName: !exists(json, 'display_name') ? undefined : json['display_name']
  }
}

export function CompanyForDisplayToJSON(value?: CompanyForDisplay | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    display_name: value.displayName
  }
}
